import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import { IconButton, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import DialogContent from '@mui/material/DialogContent'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTranslation } from 'react-i18next'

interface ResponsiveDialogProps {
  title?: string
  isOpenDialog: boolean

  setIsOpenDialog(val: boolean): void
}

const ResponsiveDialog: React.FC<ResponsiveDialogProps> = ({ title, isOpenDialog, setIsOpenDialog, children }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const handleClose = () => setIsOpenDialog(false)
  const handleOpen = () => setIsOpenDialog(true)

  const isDesktopOpen = isOpenDialog && !isSmallScreen
  const isMobileOpen = isOpenDialog && isSmallScreen

  const renderCloseButton = () => (
    <span className='absolute right-10 top-10'>
      <IconButton onClick={handleClose} size='medium' title={t('close', 'Close')}>
        <CloseIcon fontSize='large' />
      </IconButton>
    </span>
  )

  return (
    <>
      <Dialog open={isDesktopOpen} onClose={handleClose} maxWidth='lg'>
        <DialogTitle>
          <span className='text-capitalize font-bold'>{title}</span>
          {renderCloseButton()}
        </DialogTitle>
        <DialogContent className='w-600 max-w-full' dividers={!!title}>
          {children}
        </DialogContent>
      </Dialog>

      <SwipeableDrawer
        anchor='bottom'
        open={isMobileOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        disableSwipeToOpen
        swipeAreaWidth={0}
        ModalProps={{
          keepMounted: false,
        }}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            height: '98%',
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            px: '16px',
            py: '15px',
            borderBottom: '1px solid',
            borderColor: !!title ? 'divider' : '#fff',
          }}
        >
          <span className='text-capitalize font-bold flex-1 text-center text-base'>{title}</span>
          {renderCloseButton()}
        </Box>

        {/* Content */}
        <Box sx={{ p: 2, overflowY: 'auto' }}>{children}</Box>
      </SwipeableDrawer>
    </>
  )
}

export default ResponsiveDialog
